import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.input`
  ${({ theme, displayState }) => css`
    width: ${displayState?.width ?? '100%'};
    min-width: ${displayState?.minWidth ?? '120px'};
    height: 100%;
    font-size: ${displayState?.fontSize ?? '0.875rem'};
    padding: ${displayState?.padding ?? '0.375rem 0.75rem'};
    background: ${displayState?.background ?? ''};
    color: ${displayState?.color ?? theme?.colour?.secondary ?? "#555555"};
    border: ${displayState?.border ?? ''};
    outline: none;

    scrollbar-width: thin;
    scrollbar-color: #E3E3E3 transparent;
  `}
`;


export default Atom({ type: 'keyInput', dataType: ['string', 'number'], template })
